import { useReportContext } from "@/components/Evaluate/report-context";
import { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";
import { ColumnType, ReportColumn } from "@/types/evaluate";

const useSources = (columns: ReportColumn[]) => {
  const { selectedColumn } = useReportContext();

  const selectedColumnIndex = columns.findIndex(column => column.id === selectedColumn?.id);

  const truncatedColumns = columns.slice(0, selectedColumnIndex);

  return {
    [SourceType.Dataset]: truncatedColumns
      .filter(column => column.column_type === ColumnType.DATASET)
      .map(({ name }) => name),
    [SourceType.InputVariable]: [],
    [SourceType.Dependency]: truncatedColumns
      .filter(column => column.column_type !== ColumnType.DATASET)
      .map(({ name }) => name),
    [SourceType.Column]: [],
  };
};

export default useSources;
